//Document ready
$(function() {
	AsiderFilterToggle();
});

//Aside filter toggle
function AsiderFilterToggle() {
	var filterToggle = document.querySelector(".aside-filter-toggle");
	var filterForm = document.querySelector(".aside-filter form");

	if (filterToggle) {
		filterToggle.addEventListener("click", function() {
			this.classList.toggle("js-open");
			filterForm.classList.toggle("js-open");
		});
	}
}
